// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Red border for input fields */
.input-red {
    border-left: 4px solid #dc3545 !important;
}

/* Green border for input fields */
.input-green {
    border-left: 4px solid #28a745 !important;
}

/* Style unit text - keep default Bootstrap styling */
.input-group-text {
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-left: none;
    color: #495057;
    font-size: 0.875rem;
    border-radius: 0 0.25rem 0.25rem 0;
}

/* Remove left border from unit text for merged appearance */
.input-group input {
    border-right: none;
    border-radius: 0.25rem 0 0 0.25rem;
}

.input-group {
    max-width: 200px;
}

/* Card styling - remove shadow and add border */
.card {
    border: 1px solid rgba(0, 0, 0, 0.125);
    box-shadow: none !important;
}

/* Fieldset styling - border color */
fieldset.border {
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
}

.container-fluid {
    background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/rheological-hierarchy/setup/setup.component.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,yCAAyC;AAC7C;;AAEA,kCAAkC;AAClC;IACI,yCAAyC;AAC7C;;AAEA,qDAAqD;AACrD;IACI,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA,4DAA4D;AAC5D;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA,gDAAgD;AAChD;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA,oCAAoC;AACpC;IACI,iDAAiD;AACrD;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["/* Red border for input fields */\n.input-red {\n    border-left: 4px solid #dc3545 !important;\n}\n\n/* Green border for input fields */\n.input-green {\n    border-left: 4px solid #28a745 !important;\n}\n\n/* Style unit text - keep default Bootstrap styling */\n.input-group-text {\n    background-color: #e9ecef;\n    border: 1px solid #ced4da;\n    border-left: none;\n    color: #495057;\n    font-size: 0.875rem;\n    border-radius: 0 0.25rem 0.25rem 0;\n}\n\n/* Remove left border from unit text for merged appearance */\n.input-group input {\n    border-right: none;\n    border-radius: 0.25rem 0 0 0.25rem;\n}\n\n.input-group {\n    max-width: 200px;\n}\n\n/* Card styling - remove shadow and add border */\n.card {\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    box-shadow: none !important;\n}\n\n/* Fieldset styling - border color */\nfieldset.border {\n    border: 1px solid rgba(0, 0, 0, 0.125) !important;\n}\n\n.container-fluid {\n    background-color: #fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
